<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()" class="text-right" data-test="timeout-error-btn-accept">Aceptar</button>
</div>
